/* Directions helpers — deep-links into Google Maps (works on web, iOS and Android,
   no API key). Used for airports, hotels, restaurants, attractions and trip segments. */

export const directionsUrl = ({ lat, lon, name, address } = {}) => {
  const dest = lat != null && lon != null
    ? `${lat},${lon}`
    : [name, address].filter(Boolean).join(", ");
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(dest)}`;
};

export const mapSearchUrl = (query) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

/* Best directions target for a trip segment: where the traveler needs to GET TO. */
export const segmentDirectionsQuery = (seg) => {
  if (!seg) return null;
  const isCode = (s) => /^[A-Za-z]{3}$/.test((s || "").trim());
  const place = (s, suffix) => (isCode(s) ? `${s.trim().toUpperCase()} ${suffix}` : s);
  switch (seg.mode) {
    case "hotel":
    case "reservation":
      return seg.from_place || null;                          // hotel / venue address
    case "taxi":
    case "pickup":
      return seg.to_place || seg.from_place || null;          // where the ride goes
    case "flight":
      return seg.from_place ? place(seg.from_place, "airport") : null; // get to departure airport
    case "train":
    case "bus":
    case "ferry":
      return seg.from_place ? place(seg.from_place, "station") : null;
    default:
      return seg.from_place || seg.to_place || null;
  }
};
